import { useEffect, useState } from 'react';

import { useOnboardingContext } from '@/contexts/onboardingContext';

import { OnboardingStep, OnboardingNode } from '../types';
import getFirstMatching from '../utils/getFirstMatching';
import isRedirectingStep from '../utils/isRedirectingStep';
import { ONBOARDING_VERSIONS } from '../versions';

const ProgressBar = () => {
  const onboardingContext = useOnboardingContext();

  const steps = ONBOARDING_VERSIONS[onboardingContext.version];
  const currentNode = steps.find(
    (step: OnboardingNode) => step.index === onboardingContext.step - 1
  )!;
  const currentElement = getFirstMatching(
    currentNode.elements,
    onboardingContext.steps,
    onboardingContext.formOptions
  )!;
  const currentStepProps = currentElement.component.props;

  const nodesWithProgressPar = steps.filter(
    (step: OnboardingNode) => step.options?.countsTowardProgressBar
  ).length;

  const [nodesWithProgressBarCompletedOrSkipped, setNodesWithProgressBarCompletedOrSkipped] =
    useState(0);

  useEffect(() => {
    const countCompletedOrSkipped = Object.values(onboardingContext.steps).filter(
      (step: OnboardingStep[]) =>
        step.some(
          (s: OnboardingStep) => (s.submitted || s.skipped) && s.options?.countsTowardProgressBar
        )
    ).length;

    setNodesWithProgressBarCompletedOrSkipped(countCompletedOrSkipped);
  }, [onboardingContext.step]); // eslint-disable-line react-hooks/exhaustive-deps

  const stepCounter =
    nodesWithProgressBarCompletedOrSkipped + (currentNode.options?.countsTowardProgressBar ? 1 : 0);

  return (
    !currentNode.options?.hideProgressBar && (
      <>
        <p className="text-sm text-gray-500">
          {!isRedirectingStep(currentStepProps) && currentStepProps.displayName}
        </p>
        <div className="flex flex-row items-center gap-2 mb-6">
          <label htmlFor="progress-bar" className="text-base">
            {stepCounter}/{nodesWithProgressPar}
          </label>
          <progress
            id="progress-bar"
            className="h-3 w-20 rounded-md [&::-webkit-progress-bar]:rounded-md [&::-webkit-progress-value]:rounded-md [&::-webkit-progress-bar]:bg-slate-600 [&::-webkit-progress-value]:bg-green-500 [&::-moz-progress-bar]:bg-green-500"
            value={stepCounter}
            max={nodesWithProgressPar}
          />
        </div>
      </>
    )
  );
};

export default ProgressBar;
